$(function(){
	setTimeout(function(){
		$('#header .headerFW__nav__panel__custom').appendTo('.headerFW__nav__panel');
		$('.headerFW .toggler--parent span').text('Terug');
	})


	var arrKonami = [
		'https://img-comment-fun.9cache.com/media/aqo7gL/a497dEL3_700w_0.jpg',
		'https://img-comment-fun.9cache.com/media/aPv2v5B/aqxWVaWe_700w_0.jpg',
		'https://img-comment-fun.9cache.com/media/aWWjwrd/a5jPdGbg_700w_0.jpg',
		'https://img-comment-fun.9cache.com/media/abn4WB/a76WdeeQ_700w_0.jpg',
		'https://img-comment-fun.9cache.com/media/aPM72KR/aZlzXAWY_700w_0.jpg',
	];
	new app.Konami({
	    code : function(){
	      	$('#container img').each(function(){
	    		var i = Math.floor(Math.random()*arrKonami.length);
	      		$(this).replaceWith('<img src="'+arrKonami[i]+'" alt="" />')
	      	});
	    }
	 });
});


// WEBPACK FOOTER //
// ./src/themes/altradbenelux/altradbenelux.js